import clsx from "clsx";
import React from "react";
import { useDispatch } from "react-redux";
import Button from "web/react/components/LEGACY_button/button";
import AppStoreDetails from "web/react/components/app-store-details/app-store-details";
import { closeAssistedSearch } from "web/redux/ducks/app-header-bar";
import { openCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import lystMobileDevicesImage from "./images/lyst-mobile-devices.png";
import styles from "./send-to-app-banner.module.css";

interface SendToAppBannerProps {
    className?: string;
    analyticsLabel: string;
    branchLink: string;
}

export default function SendToAppBanner({
    className,
    analyticsLabel,
    branchLink,
}: SendToAppBannerProps): JSX.Element {
    const dispatch = useDispatch();

    function onCtaClick(): void {
        analytics.event("send_to_app", "cta_clicked", analyticsLabel);
        dispatch(
            openCustomerCaptureOverlay({
                captureType: "qr_code",
                branchLink,
            })
        );
        dispatch(closeAssistedSearch());
    }

    return (
        <div className={clsx(styles.sendToAppBannerContainer, className)}>
            <div className={styles.title}>
                {gettext("app_download_desktop_banner.searches_in_one_place")}
            </div>
            <AppStoreDetails className={styles.appReviews} />
            <img src={lystMobileDevicesImage} className={styles.mobileDevicesImage} />
            <Button className={styles.downloadCta} styleType={"cta"} onClick={onCtaClick}>
                {gettext("app_landing.download_free.button")}
            </Button>
        </div>
    );
}
